import { render, staticRenderFns } from "./UploadCads.vue?vue&type=template&id=935664b0&scoped=true&"
import script from "./UploadCads.vue?vue&type=script&lang=js&"
export * from "./UploadCads.vue?vue&type=script&lang=js&"
import style0 from "./UploadCads.vue?vue&type=style&index=0&id=935664b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935664b0",
  null
  
)

export default component.exports